//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



import Component from '../../../base/Component'

const NjSidebar = Component.extend({
  name: 'NjSidebar',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    fixedClasses: {
      type: [String, Array, Object],
      default: () => ({
        backdrop:
          'fixed z-400 bg-black bg-opacity-75 w-full h-full left-0 top-0 fixed',
        sidenav:
          'bg-white fixed left-0 top-0 z-700 duration-200 transition-transform h-full overflow-scroll'
      })
    }
  },
  data: () => ({
    showBackdrop: false
  }),
  methods: {
    handleClose () {
      this.$emit('update:show', false)
    }
  }
})

export default NjSidebar
